import { dateFormatter } from 'app/shared/utils/datetime';
import { eventOrganizedAsConfig } from 'app/shared/utils/eventOrganizedAsConfig';
import { eventTypeConfig } from 'app/shared/utils/eventTypeConfig';

export const COMMERCIAL_PARTNERSHIP_EVENT = 'CommercialPartnershipEvent';
export const DISCOVERY_EVENT = 'DiscoveryEvent';
export const FEATURED_SET_EVENT = 'FeaturedSetEvent';
export const PRIVATE_DISCOVERY_EVENT = 'PrivateDiscoveryEvent';
export const EVENT_FORMAT_EXPERIMENT = 'EventFormatExperiment';

// Event Owner Types
export const O_AND_O = 'o_and_o';
export const CURATOR_COMMERCIAL = 'curator_commercial';
export const CURATOR_NONCOMMERCIAL = 'curator_noncommercial';
export const CURATOR_OWNER_COMMERCIAL = 'curator_owner_commercial_event';
export const CURATOR_OWNER_NONCOMMERCIAL = 'curator_owner_noncommercial_event';

export const eventAttendeeOccasions: { [key: string]: string } = {
  birthday: 'Birthday',
  anniversary: 'Anniversary',
  date_night: 'Date night',
  other: 'Other',
};

export const merchandisingPropertyGroupNames = [
  'Genre Information',
  'Seating Information',
  'Vibe Description',
  'Other',
];

// Max tickets per event purchasable by one user
export const MAX_TICKETS = 50;

export const getNoNeighborhoodYetText = (intl: any) =>
  intl.formatMessage({
    id: 'shared.noNeighborhoodYet',
  });

export const EventStatus = {
  NONE: 0,
  CANCELLED: 1,
  SOLDOUT: 2,
  PAUSED: 3,
};

// See also similar constant in EventTimes::EventTimesConfig in backend
export const eventTimeBeforeWhichAssumeNextDay = '06:00';

// Given e.g. '2025-02-16T01:05:00Z'
// Returns e.g. '01:05:00'
const timeStrFromDateTimeStr = (dateTimeStr: string) => {
  const timeParts = dateTimeStr.match(/(\d\d:\d\d:\d\d)/);
  return timeParts && timeParts[1] ? timeParts[1] : dateTimeStr;
};

// Given e.g. '07:05:00' or '07:05'
// Returns e.g. 7
const hourNumFromTimeStr = (timeStr: string) => Number(timeStr.split(':')[0]);

// dateTimeStr = a full datetime string e.g. '2025-02-16T01:05:00Z'
export const isTimeStrNextDay = (dateTimeStr?: string, timezone?: string) => {
  if (!dateTimeStr) {
    return false;
  }

  const timeStr = timezone
    ? dateFormatter(dateTimeStr, 'hoursMinutesSeconds', timezone)
    : timeStrFromDateTimeStr(dateTimeStr);

  return !!(
    timeStr &&
    hourNumFromTimeStr(timeStr) <
      hourNumFromTimeStr(eventTimeBeforeWhichAssumeNextDay)
  );
};

// Returns true or false
export const enabledForEventOrganizedAs = (
  eventOrganizedAs?: string,
  featureKey?: string
) =>
  !!(
    eventOrganizedAs &&
    featureKey &&
    eventOrganizedAsConfig[eventOrganizedAs] &&
    // @ts-ignore
    eventOrganizedAsConfig[eventOrganizedAs][featureKey]
  );

// Returns an array of eventOrganizedAs keys, e.g. ['o_and_o', 'producer']
export const eventOrganizedAsListForEnabledFeature = (featureKey?: string) =>
  featureKey
    ? Object.keys(eventOrganizedAsConfig).filter(
        (eventOrganizedAs: string) =>
          !!(
            eventOrganizedAsConfig[eventOrganizedAs] &&
            // @ts-ignore
            eventOrganizedAsConfig[eventOrganizedAs][featureKey]
          )
      )
    : [];

// Returns true or false
export const enabledForEventType = (eventType?: string, featureKey?: string) =>
  !!(
    eventType &&
    featureKey &&
    eventTypeConfig[eventType] &&
    // @ts-ignore
    eventTypeConfig[eventType][featureKey]
  );

// Returns an array of eventType keys, e.g. ['DiscoveryEvent', 'CommercialPartnershipEvent']
export const eventTypeListForEnabledFeature = (featureKey?: string) =>
  featureKey
    ? Object.keys(eventTypeConfig).filter(
        (eventType: string) =>
          !!(
            eventTypeConfig[eventType] &&
            // @ts-ignore
            eventTypeConfig[eventType][featureKey]
          )
      )
    : [];
